import axios from "axios";
import ipApiClient from "../../api/ipApiClient";

/**
 * Get public IP address of current user
 * @returns {Promise<string>}
 */
export const getPublicIp = async () => {
  const response = await axios.get("https://api.ipify.org?format=json");
  return response.data.ip;
};

/**
 * Get IP details from IPAPI
 * @param {string} ipAddress
 * @returns {Promise<Object>}
 */
export const getIpDetails = async (ipAddress) => {
  const response = await ipApiClient.get(`/${ipAddress}`);
  return response.data;
};

/**
 * Get weather data from Open-Meteo API
 * @param {number} latitude
 * @param {number} longitude
 * @returns {Promise<Object>}
 */
export const getWeatherByCoordinates = async (latitude, longitude) => {
  const response = await axios.get(
    "https://api.open-meteo.com/v1/forecast",
    {
      params: {
        latitude,
        longitude,
        current: "temperature_2m,weather_code,wind_speed_10m",
      },
    }
  );
  const current = response.data.current;
  const current_units = response.data.current_units;

  return {
    temperature: current.temperature_2m,
    temperature_2m: current_units.temperature_2m,
    windSpeed: current.wind_speed_10m,
    weatherCode: current.weather_code,
  };
};

/**
 * Full flow:
 * Get user IP → Get location → Get weather
 * @returns {Promise<Object>}
 */
export const getUserWeatherData = async () => {
  const ip = await getPublicIp();
  const location = await getIpDetails(ip);
  const weather = await getWeatherByCoordinates(
    location.latitude,
    location.longitude
  );

  return {
    ip,
    city: location.city,
    region_code: location.region_code,
    country: location.country_name,
    latitude: location.latitude,
    longitude: location.longitude,
    temperature: weather.temperature,
    temperature_2m: weather.temperature_2m,
    windSpeed: weather.windSpeed,
    weatherCode: weather.weatherCode,
  };
};